import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';
import { FilesService } from '~/services/modules/stocks/files';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '../grid/layout/grid-layout-manager';
import { ComponentBase } from '~/infrastructure/component-base';
import { DataWithPagingMetadata } from '~/infrastructure/paging';

@Component({
    selector: 'app-documents-grid',
    templateUrl: './documents-grid.component.html',
    styleUrls: ['./documents-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DocumentsGridComponent
extends ComponentBase
implements OnInit {
  @Input() _active: boolean = true;
  _documentsGridColumns: any[] = [];
  @Output() closeDocumentsWindowEvent : EventEmitter<boolean> = new EventEmitter<boolean>();
  _theme: string;
  _storagePath: string;
  _page: string = 'documents';
  @Input() gridData: any;
  constructor(private _themeManager: ThemeManagerService,
    private _filesService: FilesService,
    private _gridFields: GridFieldsService,
    private _gridLayoutManagerService: GridLayoutManagerService,
  ) {
    super();
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

   }

  ngOnInit(): void {
    this._storagePath = EnvironmentLoaderService.envConfig.enterpriseApiLocal+'/';
    this._gridFields
    .getGridFieldsByPage(this._page)
    
    .subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects(this._page, data);
    });

  this.registerSubscription(
    this._gridLayoutManagerService.subscribeToColumnsChanges(
      this._page,
      (gridColumns) => {
        this._documentsGridColumns = gridColumns;
      }
    )
  );
  }
  _closeDocumentsWindow(): void {
    this._active = false;
    this.closeDocumentsWindowEvent.emit(false);
  }
  setFileSize(e:number){
    return Math.round(e/1000);
  }
  downloadFile(url: string, fileName: string ){
    this._filesService.downloadFilebyPath(url).subscribe((blob: any) => {
      const a = document.createElement('a')
        const objectUrl = URL.createObjectURL(blob)
        a.href = objectUrl
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
    })
  }
  getAccountsString(accountSites: any) {
    let accounts = '';
    let counter = 0;
    accountSites.forEach((element: any) => {
      if (element.account) {
        if (counter > 0) {
          accounts += ', ';
        }
        accounts += element.account.name;
        counter++;
      }
    });

    return accounts;
  }
  _getFiles = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var ids : string = '';
    if(this.gridData)
      {

        let counter = 0;
        this.gridData.forEach((element: any) => {
      if (element) {
        if (counter > 0) {
          ids += ', ';
        }
        ids += element;
        counter++;
      }
    });
      }
    return this._filesService.getDocumentsByIds(params, model, ids);
  }
}
